import ImageUploader from './tools/ImageUploader'
import DownDrawer from './tools/DownDrawer'
export default {
  install (Vue) {
    Vue.component(ImageUploader.name, ImageUploader)
    Vue.component(DownDrawer.name, DownDrawer)
  }
}
